var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManualFuelevent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0528 4.24673L22.8504 1.05201L20.6999 3.19472L17.4975 0C14.9989 0 13.5988 0 11.1003 0L0.440918 10.6516C-0.146973 11.2395 -0.146973 12.191 0.440918 12.7866L8.97306 21.3033C9.56095 21.8912 10.5201 21.8912 11.108 21.3033L24.9699 7.44919L23.9024 6.38944L26.0528 4.24673ZM10.0328 9.58415L7.8901 7.44919L12.1678 3.18698H16.4455L10.0328 9.58415Z",
    fill: "#BD3B52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6528 15.9355C24.6528 15.9355 20.2977 22.2399 20.2977 24.6456C20.2977 27.0513 22.2471 29.0006 24.6528 29.0006C27.0585 29.0006 29.0078 27.0513 29.0078 24.6456C29.0078 22.2399 24.6528 15.9355 24.6528 15.9355Z",
    fill: "#BD3B52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1073 10.1416C26.1073 10.1416 24.6604 12.2385 24.6604 13.0431C24.6604 13.8478 25.3103 14.4978 26.1073 14.4978C26.9043 14.4978 27.5542 13.8478 27.5542 13.0431C27.5542 12.2385 26.1073 10.1416 26.1073 10.1416Z",
    fill: "#BD3B52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualFuelevent);
export default __webpack_public_path__ + "static/media/Manual Fuel event.f8d32e7df80cddce21a14c7640ff6dfa.svg";
export { ForwardRef as ReactComponent };